import { MissionsUrlProvider } from '@/features/missions/context/MissionsUrlProvider'
import { AssessmentTask } from '@/features/nectar/components/AssessmentTask'
import { Page } from '@/ui-kit'

const AssessmentWebviewPage = () => {
  return (
    <MissionsUrlProvider isWebview={true}>
      <Page>
        <AssessmentTask />
      </Page>
    </MissionsUrlProvider>
  )
}

export default AssessmentWebviewPage
